import { useEffect, useRef, useState } from "react";
import TooltipPortal from "./TooltipPortal";

const DISPLAY_CH = 36; // visible characters before truncation UI kicks in

export default function TruncateWithTooltip({ text, className = "" }) {
  const wrapRef = useRef(null);
  const textRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);
  const [open, setOpen] = useState(false);

  const recalc = () => {
    const el = textRef.current;
    if (!el) return;
    setIsTruncated(el.scrollWidth > el.clientWidth);
  };

  useEffect(() => {
    recalc();
  }, [text]);

  useEffect(() => {
    recalc();
    const ro = new ResizeObserver(recalc);
    if (textRef.current) ro.observe(textRef.current);
    const onResize = () => recalc();
    window.addEventListener("resize", onResize);
    return () => {
      ro.disconnect();
      window.removeEventListener("resize", onResize);
    };
  }, []);

  return (
    <>
      <span
        ref={wrapRef}
        className={`relative inline-block align-middle min-w-0 ${className}`}
        style={{ maxWidth: `${DISPLAY_CH}ch` }}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        tabIndex={0}
      >
        <span
          ref={textRef}
          className="block overflow-hidden text-ellipsis whitespace-nowrap"
          aria-label={text}
        >
          {text}
        </span>
      </span>

      <TooltipPortal open={open && isTruncated} anchorEl={wrapRef.current} text={text} />
    </>
  );
}
